(function () {
  var popup = document.getElementById('dc-launch-promo');
  if (!popup) return;

  var STATE_KEY = 'dc_signup_state'; // 'dismissed' | 'submitted'
  var TIMER_MS = 5000;

  function getState() {
    try { return localStorage.getItem(STATE_KEY); } catch (e) { return null; }
  }
  function setState(v) {
    try { localStorage.setItem(STATE_KEY, v); } catch (e) {}
  }

  function open() {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    popup.hidden = true;
    document.body.style.overflow = '';
    window.dispatchEvent(new CustomEvent('dc:launch-promo-closed'));
  }

  popup.querySelectorAll('[data-launch-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      close();
      if (getState() !== 'submitted') setState('dismissed');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) close();
  });

  // Copy discount code to clipboard on click. There can be more than one
  // trigger (the overlay on the artwork's code pill, plus the success bar).
  popup.querySelectorAll('[data-copy-code]').forEach(function (codeBtn) {
    var hint = codeBtn.querySelector('[data-copy-hint]');
    var restore = hint ? hint.textContent : '';
    codeBtn.addEventListener('click', function () {
      var code = codeBtn.getAttribute('data-code');
      function flash(text) {
        if (!hint) return;
        hint.textContent = text;
        setTimeout(function () { hint.textContent = restore; }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { flash('Copied!'); }).catch(function () { flash('Copy failed'); });
      } else {
        flash('Copy failed');
      }
    });
  });

  // "Sign in" links (pre-submit form panel + post-submit success panel):
  // Shopify's account sheet only opens on a genuinely user-trusted click on
  // the header icon itself -- JS can't dispatch a synthetic click that
  // triggers it (by design, since it's part of the sign-in flow), so this
  // just closes the popup and lets the real /account link do its own
  // navigation to Shopify's hosted sign-in page.
  popup.querySelectorAll('[data-open-native-signin]').forEach(function (el) {
    el.addEventListener('click', function () {
      close();
    });
  });

  // Just redirected back from a successful native form submission: the
  // popup is already server-rendered open (no `hidden` attribute) in its
  // success state -- just persist that so the timer/account-icon logic
  // never shows the signup form again for this visitor.
  if (popup.getAttribute('data-just-submitted') === 'true') {
    setState('submitted');
    document.body.style.overflow = 'hidden';
  } else {
    var state = getState();
    if (state !== 'submitted' && state !== 'dismissed') {
      setTimeout(function () {
        if (getState() == null) open();
      }, TIMER_MS);
    }
  }

  // Intercept the header account icon for logged-out, not-yet-submitted
  // visitors so it opens this promo instead of Shopify's native sign-in
  // dialog (a closed shadow-DOM component we can't brand). Capture phase
  // on document runs before the shadow-DOM component's own click handling,
  // so stopping propagation here reliably prevents its dialog from opening.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.account-button');
    if (!btn) return;
    if (btn.getAttribute('data-customer-logged-in') === 'true') return;
    if (getState() === 'submitted') return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  // Top announcement banner's "10% off" message dispatches this instead of
  // duplicating the open/state logic.
  window.addEventListener('dc:open-launch-promo', function () {
    if (getState() === 'submitted') return;
    open();
  });
})();
